module.exports = __webpack_public_path__ + "img/top.57cce454.svg";